(() => {
  const name = 'global';

  App[name] = (() => {
    const isStorageSupported = (storage) => {
      const key = 'key';
      try {
        storage.setItem(key, '1');
        storage.removeItem(key);
        return true;
      } catch (error) {
        return false;
      }
    };

    return {
      toggleExpansion(target) {
        $(target).toggleClass('expanded');
        $(target).next().toggleClass('show');
        // todo rewrite the implementation
      },

      isLocalStorageSupported() {
        return isStorageSupported(window.localStorage);
      },

      isSessionStorageSupported() {
        return isStorageSupported(window.sessionStorage);
      },

      clearLocalStorage(items) {
        if (items && App.global.isLocalStorageSupported()) {
          $(items).each((index, item) => {
            window.localStorage.removeItem(item);
          });
        }
      },

      resetCountry() {
        if (App.global.isLocalStorageSupported()) {
          const countryPrefix = window.dataLayer.brandCountryPrefixUrl;
          const countryHasChanged = countryPrefix !== window.localStorage.getItem('brandCountryPrfxUrl');
          if (countryHasChanged) {
            window.localStorage.setItem('brandCountryPrfxUrl', countryPrefix);
          }
          window.dataLayer.countryHasChanged = countryHasChanged;
        }
      },

      getScreenSize() {
        const screenWidth = window.innerWidth;
        switch (true) {
          case screenWidth > 1024:
            return 'desktop';
          case screenWidth <= 1024 && screenWidth >= 768:
            return 'tablet';
          case screenWidth < 768:
            return 'mobile';
          default:
            return false;
        }
      },

      isDesktop() {
        return App.global.getScreenSize() === 'desktop';
      },

      isTablet() {
        return App.global.getScreenSize() === 'tablet';
      },

      isMobile() {
        return App.global.getScreenSize() === 'mobile';
      },

      specifyDevice() {
        $('body')
          .removeClass('desktop tablet mobile')
          .addClass(App.global.getScreenSize());
      },

      isInViewportY(element, delta) {
        // Is element in viewport by y axis only.
        // Delta is a number of pixels element can be hidden by screen bounds.
        let bounds = null;
        const deltaY = delta || 0;
        const nativeElement = $(element).get(0);
        if (nativeElement) {
          bounds = nativeElement.getBoundingClientRect();
          return bounds.bottom - deltaY < window.innerHeight && bounds.top > -deltaY;
        }
        return false;
      },

      isPortraitOrientation() {
        return window.innerHeight >= window.innerWidth;
      },

      isAndroid() {
        const { userAgent } = navigator;
        return userAgent.match(/Android/i) !== null;
      },

      isTouchDevice() {
        /* global DocumentTouch */
        return ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) === true;
      },

      isIOS() {
        const iDevices = [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ];
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true;
          }
        }
        return false;
      },

      isEdgeBrowser() {
        return window.navigator.userAgent.indexOf('Edge') > -1;
      },

      getCookie(cName, defaultValue) {
        if (!cName || typeof cName !== 'string') {
          return defaultValue !== undefined ? defaultValue : null;
        }
        const c = document.cookie.split(/[,;]/);
        for (let i = 0; i < c.length; i += 1) {
          if (c[i].split('=')[0].trim() === cName) {
            return decodeURIComponent(c[i].substring(c[i].indexOf('=') + 1));
          }
        }
        return defaultValue !== undefined ? defaultValue : null;
      },

      setCookie(sName, sValue, path, expires) {
        if (/Date/.test(Object.prototype.toString.call(path))) {
          const tmp = expires;
          /* eslint-disable no-param-reassign */
          expires = path;
          path = tmp;
          /* eslint-enable no-param-reassign */
        }
        let cStr = `${sName}=${encodeURIComponent(sValue)}`;
        if (expires && typeof expires.toUTCString === 'function') {
          cStr += `;expires=${expires.toUTCString()}`;
        }
        if (path) {
          cStr += `;path=${path}`;
        }
        if (window.location.protocol === 'https:') {
          cStr += ';secure';
        }

        document.cookie = cStr;
      },

      removeCookie(sName, path) {
        App.global.setCookie(sName, '', path, new Date('1970-01-01'));
      },

      integersAreEqual(int1, int2, radix) {
        return parseInt(int1, radix || 10) === parseInt(int2, radix || 10);
      },

      arraysAreEqual(arr1, arr2) {
        const arrLength = arr1.length;
        if (!arr1 || !arr2) {
          return false;
        }
        if (arr2.length !== arrLength) {
          return false;
        }

        for (let i = 0; i < arrLength; i += 1) {
          if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
            if (!arr1[i].equals(arr2[i])) {
              return false;
            }
          } else if (arr1[i] !== arr2[i]) {
            return false;
          }
        }
        return true;
      },

      objectsAreEqual(a, b) {
        let propName = '';
        const aProps = Object.getOwnPropertyNames(a);
        const bProps = Object.getOwnPropertyNames(b);

        if (aProps.length !== bProps.length) {
          return false;
        }

        for (let i = 0; i < aProps.length; i += 1) {
          propName = aProps[i];
          if (a[propName] !== b[propName]) {
            return false;
          }
        }

        return true;
      },

      isNotEmpty(value) {
        return typeof value !== 'undefined' && value !== null && value !== '';
      },

      minSize(value, minSize) {
        return typeof value !== 'undefined' && value !== null && value !== '' && value.length >= minSize;
      },

      maxSize(value, maxSize) {
        return typeof value === 'string' && value.length <= maxSize;
      },

      svgBannersScaleOnIE() {
        if (document.getElementsByTagName('html')[0].className.indexOf('IE') > -1) {
          $('.js-svg-banner')
            .each(function handleSvg() {
              const $svg = $(this).find('svg');
              const $image = $svg.find('image');
              if ($image.length) {
                $svg.attr({
                  height: $image[0].height.baseVal.value,
                  width: $image[0].width.baseVal.value,
                });
                $(this).css('display', 'block');
              }
            });
        }
      },

      getClosestValueFromArray(value, array) {
        if (array.length) {
          // Exclude Type Error when array is empty
          return array.reduce((prev, curr) => (
            Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
          ));
        }
        return undefined;
      },

      convertObjectParamsWithHashmap(obj, hashmap, reverse) {
        const convertedParams = {};
        $.each(hashmap, (leftName, rightName) => {
          const oldParamName = reverse ? leftName : rightName;
          const newParamName = reverse ? rightName : leftName;
          convertedParams[oldParamName] = obj[newParamName];
        });
        return convertedParams;
      },

      convertToNumber(price) {
        return parseFloat(price.toString().replace(',', '.'));
      },

      countDecimals(value) {
        if (Math.floor(value) === value || typeof (value) === 'undefined') {
          return 0;
        }
        return value.toString().split('.')[1].length || 0;
      },

      powerFormat(power, addPlus, addZeros) {
        if (power === null) return '';
        let newPower = (addPlus && power > 0) ? `+${power}` : power;
        const decimals = App.global.countDecimals(power);
        if (addZeros && decimals < 2) {
          if (decimals === 0) {
            newPower = `${newPower}.00`;
          } else if (decimals === 1) {
            newPower = `${newPower}0`;
          }
        }
        return newPower;
      },

      priceFormat(unformattedPrice, quantity) {
        if (typeof unformattedPrice === 'string' && unformattedPrice.indexOf(' ') !== -1) {
          // price is not unformatted
          return unformattedPrice;
        }
        const { priceFormatTempl } = window;
        const tempArr = priceFormatTempl.split('');
        const tempArrLength = tempArr.length;
        const itemQuantity = typeof quantity === 'undefined' ? 1 : quantity;
        let tempPrice = [];
        let result = '';
        let j = 0;
        const isFloat = (n) => n === Number(n) && n % 1 !== 0;

        let price = unformattedPrice.toString().replace(',', '.');
        if (priceFormatTempl.indexOf('.') > -1) {
          price = parseFloat(price).toFixed(2);
        }

        price *= itemQuantity;

        price = isFloat(price) ? parseFloat(price).toFixed(2) : price;

        if (typeof price === 'number') {
          price = price.toFixed(2);
        }

        tempPrice = price.toString().split('.');

        for (let i = 0; i < tempArrLength; i += 1) {
          if (tempArr[i] === '0') {
            // eslint-disable-next-line no-plusplus
            result += tempPrice[j] ? tempPrice[j++] : '';
          } else {
            result += tempArr[i];
          }
        }

        return result.replace('.', ',').trim();
      },

      hasParent(element, selector) {
        const $selector = $($.isArray(selector) ? selector.toString() : selector);
        let found = false;
        $(element[0])
          .parents()
          .addBack()
          // eslint-disable-next-line consistent-return
          .each(function hasParentNodeGlobal() {
            if ($.inArray(this, $selector) !== -1) {
              found = true;
              return false;
            }
          });
        return found;
      },

      serializeFormToObject($form) {
        const o = {};
        const a = $form.serializeArray();
        $.each(a, function serializeFormToObjectGlobal() {
          if (o[this.name]) {
            if (!o[this.name].push) {
              o[this.name] = [o[this.name]];
            }
            o[this.name].push($.trim(this.value) || '');
          } else {
            o[this.name] = $.trim(this.value) || '';
          }
        });
        return o;
      },

      sendErrorLog(message) {
        window.dataLayer.push(
          {
            event: 'error',
            errorMessage: message,
          },
        );
      },

      animationEndEvent: (() => {
        let t;
        const el = document.createElement('fakeelement');
        const animations = {
          animation: 'animationend',
          MozAnimation: 'animationend',
          WebkitAnimation: 'webkitAnimationEnd',
        };

        // eslint-disable-next-line no-restricted-syntax
        for (t in animations) {
          if (el.style[t] !== undefined) {
            return animations[t];
          }
        }
        return '';
      })(),

      transitionEndEvent: (() => {
        let t;
        const el = document.createElement('fakeelement');
        const transitions = {
          transition: 'transitionend',
          MozTransition: 'transitionend',
          WebkitTransition: 'webkitTransitionEnd',
        };

        // eslint-disable-next-line no-restricted-syntax
        for (t in transitions) {
          if (el.style[t] !== undefined) {
            return transitions[t];
          }
        }
        return '';
      })(),

      isOriginalEvent(event) {
        return typeof event.originalEvent !== 'undefined';
      },

      scrollAnimate(position, duration = 200, cb) {
        let $header = null;
        let isDone = false;
        const runCallbackOnce = () => {
          if (!isDone && typeof cb === 'function') {
            cb();
            isDone = true;
          }
        };

        if (position) {
          $header = $('.top-menu-wrapper .top-menu');
          const scrollTop = position - $header.outerHeight();

          $('html, body').animate({ scrollTop }, duration, runCallbackOnce);
        }
      },

      fixedMenuOnScroll(className, rightContent, leftMenu) {
        const isTablet = App.global.isTablet();
        if (!rightContent.length || !leftMenu.length) {
          return;
        }

        if (isTablet) {
          $(window)
            .scroll(() => {
              const currentTop = $(window).scrollTop();
              const menuTopPosition = rightContent.offset().top;
              const bottomStopPosition = $('.footer').offset().top;

              leftMenu.toggleClass(className, currentTop >= menuTopPosition);
              if (bottomStopPosition < currentTop + leftMenu.outerHeight()) {
                // eslint-disable-next-line max-len
                const fixedTopPosition = leftMenu.outerHeight() - Math.abs((currentTop - bottomStopPosition));
                leftMenu.css('top', `-${fixedTopPosition}px`);
              } else {
                leftMenu.removeAttr('style');
              }
            });
        }
      },

      disableIosScale() {
        if (App.global.isIOS()) {
          const $viewportmeta = $('meta[name="viewport"]');
          $viewportmeta
            .attr('content', 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0, shrink-to-fit=no, user-scalable=no');
        }
      },

      enablePrerender() {
        let markup = '';
        const preloadedPages = window.dataLayer.preRenderedPages;

        if (window.dataLayer.isPrerenderActive) {
          // eslint-disable-next-line no-restricted-syntax
          for (const page in preloadedPages) {
            if (App.global.objHasProp(preloadedPages, page)
              && preloadedPages[page].isPrerenderNeeded) {
              markup = `${markup}
                <link rel="prerender" href="${preloadedPages[page].url}"/>
                <link rel="prefetch" href="${preloadedPages[page].url}"/>`;
            }
          }
          $('head').append(markup);
        }
      },

      isFontAvailable(fontName) {
        let monoWidth = 0;
        let serifWidth = 0;
        let sansWidth = 0;
        let width = 0;
        const { body } = document;
        let container = document.createElement('div');
        const containerCss = [
          'position:absolute',
          'width:auto',
          'font-size:128px',
          'left:-99999px',
        ];
        const calculateWidth = (fontFamily) => {
          container.style.fontFamily = fontFamily;
          body.appendChild(container);
          width = container.clientWidth;
          body.removeChild(container);
          return width;
        };

        container.innerHTML = `<span style="${containerCss.join(' !important;')}">${Array(100).join('wi')}</span>`;
        container = container.firstChild;

        monoWidth = calculateWidth('monospace');
        serifWidth = calculateWidth('serif');
        sansWidth = calculateWidth('sans-serif');

        return monoWidth !== calculateWidth(`${fontName},monospace`)
          || sansWidth !== calculateWidth(`${fontName},sans-serif`)
          || serifWidth !== calculateWidth(`${fontName},serif`);
      },

      getOpticianImageUrl(listImageUrl, largeImageUrl) {
        if (App.global.isImageNotEmpty(listImageUrl)) {
          return listImageUrl;
        }
        if (App.global.isImageNotEmpty(largeImageUrl)) {
          return largeImageUrl;
        }
        return '/images/server/optiker.svg';
      },

      getEmptyInvisibleImage() {
        return App.settings.emptyInvisibleImage || '';
      },

      isImageNotEmpty(url) {
        return url.indexOf(App.global.getEmptyInvisibleImage()) === -1;
      },

      showDomElement(domElement, show) {
        if (domElement !== null) {
          // eslint-disable-next-line no-param-reassign
          domElement.style.display = show ? 'block' : 'none';
        }
      },

      preloadImage(url) {
        if (url) {
          new Image().src = url;
        }
      },

      isCsiUser() {
        return App.settings.isCsiUser || (typeof window.dataLayer.isCsiUser !== 'undefined' && window.dataLayer.isCsiUser);
      },

      uncacheimages() {
        $(() => {
          $('img')
            .each(function appendTimestampToUncacheImageUrls() {
              this.src += `${this.src.indexOf('?') < 0 ? '?' : '&'}_=${Date.now()}`;
            });
          $('body *')
            .each(function appendTimestampToUncacheInlineImageUrls() {
              if (/url\(/.test($(this).css('background-image'))) {
                const url = $(this).css('background-image').replace(/^.*url\(|\).*/g, '');
                $(this).css('background-image', `url(${url}${url.indexOf('?') < 0 ? '?' : '&'}_=${Date.now()})`);
              }
            });
        });
      },

      csiPing(url) {
        setInterval(() => {
          $.ajax({
            type: 'POST',
            url,
          });
        }, 60000);
      },

      disableScrollRestoration(disable, pos) {
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = disable ? 'manual' : 'auto';
        } else if (disable === true && typeof pos === 'number') {
          $(window).on('unload', () => {
            $(window).scrollTop(pos);
          });
        }
      },

      runOnWindowLoad(cb, postpone) {
        const runCb = postpone
          ? () => setTimeout(cb, 0)
          : cb;
        if (document.readyState === 'complete') {
          runCb();
        } else {
          $(window).on('load', runCb);
        }
      },

      runOnImageLoad(image, cb) {
        const runCb = () => setTimeout(cb, 500);
        const $image = $(image);
        const imageLoaded = $image.width() > 0;
        if (imageLoaded) {
          runCb();
        } else {
          $image.on('load', runCb);
        }
      },

      cdnDomain: 'https://lwg-res.cloudinary.com',

      getCdnImageUrlRaw(params) {
        const relativeImageUrl = params.url.split('.com')[1] || params.url;
        return `${App.global.cdnDomain}/v1/product${relativeImageUrl}`;
      },

      getCdnImageUrl(params) {
        const trueWidth = params.sizes ? parseInt(params.sizes, 10) : '{width}';
        const trimLevel = params.productType === 'LENS' ? '/e_trim:5' : '/e_trim:0';
        const trimWhiteSpace = params.trim ? trimLevel : '';
        const linkParams = `${trimWhiteSpace}/t_img-trans,f_auto,w_${trueWidth},c_scale/v1/product`;
        const relativeImageUrl = params.url.split('.com')[1] || params.url;
        return App.global.cdnDomain + linkParams + relativeImageUrl;
      },

      cdnImage(options) {
        const params = $.extend({}, options);
        if (!params.url) {
          return false;
        }

        const cdnImageUrl = App.global.getCdnImageUrl(params);
        const imgSrc = params.src === false ? '' : App.global.getEmptyInvisibleImage();

        const imageOptions = {
          id: (params.id || null),
          'data-src': cdnImageUrl,
          'data-widths': (params.widths || '[]'),
          'data-absurl': 'false',
          class: `lazyload ${params.class || ''}`,
          'data-sizes': (params.sizes || 'auto'),
          alt: (params.alt || ''),
          title: (params.title || ''),
          src: params.setMagnifySize ? cdnImageUrl : imgSrc,
        };

        const $cdnImage = $('<img>', imageOptions)
          .on('load', function onCdnImageLoad(event) {
            if (typeof params.callback === 'function') {
              params.callback(event, this);
            }
          });

        return params.callback ? $cdnImage : $cdnImage.get(0).outerHTML;
      },

      getRedirectUrl(url) {
        const { brandCountryPrefixUrl = '' } = App.settings;
        if (url.startsWith('http')) {
          return url;
        }
        if (brandCountryPrefixUrl.length) {
          if (url.startsWith(brandCountryPrefixUrl)) {
            return url;
          }
          // If url contains no starting "/", eg. "se/some-url"
          if (`/${url}`.startsWith(`${brandCountryPrefixUrl}/`)) {
            return `/${url}`;
          }
        }
        return `${brandCountryPrefixUrl}${url[0] !== '/' ? `/${url}` : url}`;
      },

      getCsrf() {
        const csrfParameter = $('meta[name="_csrf_parameter"]').attr('content');
        const csrfHeader = $('meta[name="_csrf_header"]').attr('content');
        const csrfToken = $('meta[name="_csrf"]').attr('content');
        return {
          header: csrfHeader,
          token: csrfToken,
          parameter: csrfParameter,
        };
      },

      isDiscountCodeApplied(voucher) {
        return voucher.campaign === true && voucher.code !== '';
      },

      getParameter(paramName) {
        const searchString = window.location.search.substring(1);
        let val = null;
        const params = searchString.split('&');

        for (let i = 0; i < params.length; i += 1) {
          val = params[i].split('=');
          if (val[0] === paramName) {
            return val[1];
          }
        }
        return null;
      },

      parseInt(int, radix) {
        return parseInt(int, radix || 10);
      },

      /**
       * Check if object hasOwnProperty
       * @param {Object} object - object
       * @param {String} key - property name
       */
      objHasProp(object, key) {
        return Object.prototype.hasOwnProperty.call(object, key);
      },

      /**
       * Creates a new Array instance from an array-like or iterable object.
       * IE10-11 don't work with such syntax: [...arrayLike] and throws an error.
       * @param {Object} arrayLike - An array-like or iterable object to convert to an array.
       * @returns {[]} - A new Array instance.
       */
      arrayFrom(arrayLike) {
        return Array.prototype.slice.call(arrayLike);
      },

      formatDate(dateString, format) {
        const getTwoDigitNumber = (num) => (
          num < 10 ? `0${num}` : num
        );
        try {
          const date = new Date(dateString);
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          switch (format) {
            case 'YYYY-MM-DD':
            default: {
              return `${year}-${getTwoDigitNumber(month)}-${getTwoDigitNumber(day)}`;
            }
          }
          // eslint-disable-next-line no-empty
        } catch (skipError) {}
        return '';
      },

      filterDomElementsByProductId(index, btn, productId = 0) {
        return +$(btn).attr('data-id') === +(productId !== 0 ? productId : App.productPage.currentProduct.id);
      },

      recalculateElPosition($el, defaultElPosition, $topPageStick) {
        const isPageScrolled = $('body').hasClass('scrolling');

        if (!isPageScrolled) {
          const pageStickHeight = $topPageStick.outerHeight();
          const scrollPosY = window.scrollY || window.pageYOffset;
          const pageStickInViewHeight = pageStickHeight - scrollPosY;
          $el.css('top', defaultElPosition + pageStickInViewHeight);
        } else {
          $el.css('top', defaultElPosition);
        }
      },
    };
  })();
})();
